import { UPDATE_ERROR_MESSAGE } from "../helpers/actions";
import { withProperties, isPlainObject, getValueAtPath, isString } from "../../utils";

export default function state() {
  const NAME = 'error';
  const $state = Object.create(null);

  let errorTimer = 0;

  function Reducer(state = null, action) {
    const payload = isPlainObject(action.payload) ? action.payload : {};

    switch (action.type) {
      case UPDATE_ERROR_MESSAGE: {
        const { error } = payload;
        return (isString(error) ? error.trim() : '') || null;
      }

      default: return state;
    }
  }

  function updateErrorMessage(error, duration) {
    return (dispatch, getState) => {
      const currentError = getValueAtPath(getState(), 'error');
      const parsedError = (isString(error) ? error.trim() : '') || null;

      if (parsedError !== currentError) {
        if (arguments.length > 1) {
          duration = isNaN(duration = Number(duration))
            ? Infinity
            : Math.round(Math.max(duration, 10) * 1000);
        } else {
          duration = Infinity;
        }

        if (errorTimer) {
          clearTimeout(errorTimer);
          errorTimer = 0;
        }
      
        dispatch({ type: UPDATE_ERROR_MESSAGE, payload: { error } });

        if (duration !== Infinity) {
          errorTimer = setTimeout(() => {
            clearTimeout(errorTimer);
            errorTimer = 0;
            
            // Clears the error message (no payload)
            dispatch({ type: UPDATE_ERROR_MESSAGE });
          }, duration);
        }
      }
    }
  }

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer,
    actions: withProperties(Object.create(null), { updateErrorMessage })
  });

  return (state = $state);
}
